import * as e from "react";
import i from "../lib/IconBase.es.js";
import m from "../defs/LinkSimpleBreak.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(i, { ref: a, ...r, weights: m }));
o.displayName = "LinkSimpleBreakIcon";
const p = o;
export {
  p as LinkSimpleBreak,
  o as LinkSimpleBreakIcon
};
